import { useFormController } from '@dreryk/react-common';

import { AiAssistantMainMenuTileItemIdleSoundSourceRadioGroup } from './AiAssistantMainMenuTileItemIdleSoundSourceRadioGroup';
import { AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnect } from './AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnect';
import { AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnectLoader } from './AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnect.loader';
import { AiAssistantMainMenuTileItemIdleSoundSourceFormBean } from './AiAssistantMainMenuTileItemIdleSoundSourceForm.types';
import { StyledSoundSourceForm } from './AiAssistantMainMenuTileItemIdleSoundSourceForm.styled';

export const AiAssistantMainMenuTileItemIdleSoundSourceForm = (): JSX.Element => {
   const { register, watch } = useFormController<AiAssistantMainMenuTileItemIdleSoundSourceFormBean>({});
   const soundSource = watch('soundSource');

   return (
      <StyledSoundSourceForm noValidate>
         <AiAssistantMainMenuTileItemIdleSoundSourceRadioGroup register={register} soundSource={soundSource} />
         {soundSource === 'PHONE' ? (
            <AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnectLoader>
               {({ qrCodeUrl }) => <AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnect qrCodeUrl={qrCodeUrl} />}
            </AiAssistantMainMenuTileItemIdleSoundSourcePhoneConnectLoader>
         ) : null}
      </StyledSoundSourceForm>
   );
};
